// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Maklumkan klien untuk beralih",
  "1d484fee4a": "Jabatan Kewangan, Jabatan Jualan, Pengurusan Projek, Data Perniagaan, Jabatan Produk, Jabatan Operasi, Pengurusan R&D, Perancangan Versi, Jabatan Khidmat Pelanggan, Jabatan Pentadbiran, Jabatan Perolehan, Pengurusan Selepas Jualan",
  "a2c88dfb79": "Cipta pasukan pertama anda",
  "3cfdcc6086": "Jabatan Kewangan, Jabatan Jualan, Pengurusan Projek/305, Pentadbiran HR/306, Jabatan Operasi, Pengurusan R&D, Perancangan Versi, Pengurusan Khidmat Pelanggan/403, Jabatan Perolehan, Pengurusan Selepas Jualan",
  "ac45ec2c05": "Pengesahan log masuk akaun gagal",
  "9aef9b8ccd": "Akaun yang sedang log masuk bermasalah, sila log masuk semula dan cuba lagi",
  "728dd00f22": "Pengesahan nombor telefon ini bermasalah, sila cuba log masuk menggunakan kod pengesahan SMS",
  "30dbecd916": "Maklumat yang anda masukkan mengandungi perkataan sensitif, sila ubah suai dan cuba lagi",
  "12ed508d8a": "Operasi anda terlalu kerap, sila cuba lagi nanti",
  "952d4a7595": "Status log masuk akaun semasa bermasalah, sila log masuk semula dan cuba lagi",
  "e64bfdeaa4": "Pengesahan log masuk gagal, sila dapatkan pengesahan SMS semula",
  "79008a65f1": "Nombor telefon ini telah menyertai beberapa syarikat, sila log masuk ke syarikat atau tukar nombor telefon",
  "bf242eff42": "Nama syarikat sudah wujud",
  "4f0cdb8374": "Sila masukkan nombor telefon yang lengkap. Jika anda menggunakan nombor telefon luar negara, sila tukar kepada nombor domestik (86+)",
  "46e79ffeff": "Penciptaan syarikat bermasalah, sila hubungi khidmat pelanggan rasmi untuk penyelesaian",
  "f3e18f0341": "Pengesahan parameter gagal",
  "503fd1718d": "Gagal menghantar kod pengesahan SMS",
  "24b3129f19": "Penghantaran SMS terlalu kerap, sila cuba lagi nanti",
  "1cde3e8245": "Kod pengesahan salah, sila masukkan semula",
  "4212ecc031": "Beberapa ralat pengesahan telah berlaku, pengesahan dihadkan buat sementara waktu, sila cuba lagi nanti",
  "735da9c347": "Pengesahan nama syarikat yang bertindih bermasalah, sila hubungi khidmat pelanggan rasmi untuk penyelesaian",
  "8731da9615": "Pengesahan pensijilan nama syarikat bermasalah, sila hubungi khidmat pelanggan rasmi untuk penyelesaian",
  "62e89b3f16": "Setuju dengan perjanjian perkhidmatan",
  "c9b79027e5": "Hantar kod pengesahan",
  "84c1447b9d": "Berjaya disalin",
  "fba4b0abd0": "Rekod Hos",
  "37f5a7cd41": "Nilai TXT",
  "78b12427c9": "Mengesahkan...",
  "59d089837c": "Kami tidak dapat mengesahkan domain anda pada masa ini. Anda mungkin perlu menunggu sebentar lagi untuk pembekal pengehosan domain anda mengemas kini maklumat anda. Jika tiada respons selepas beberapa ketika, sila cuba sahkan semula, atau tukar domain.",
  "4a5b7383d1": "Menyemak domain",
  "f24a492e40": "rekod pengesahan, anda boleh menutup halaman ini dan kembali semula nanti untuk menyemak.",
  "c697ca5f1a": "Selamat datang ke Versi Perusahaan",
  "ebb01b1740": "Seterusnya",
  "30109bf753": "Adakah syarikat anda mempunyai nama domain?",
  "2b3e485b47": "Saya mempunyai nama domain syarikat",
  "1a7f5eae44": "Saya tidak mempunyai nama domain syarikat",
  "bde15d6d84": "Anda perlu mempunyai nama domain (contohnya example.com) untuk kami membuat akaun syarikat untuk anda",
  "07ffb22c90": "Maaf, anda perlu mempunyai nama domain untuk membuat akaun syarikat untuk syarikat anda",
  "de23836563": "Sila masukkan nama domain yang digunakan untuk membuat akaun syarikat",
  "287c07944a": "Sahkan nama domain anda",
  "3ea2d528d5": "Lengkapkan langkah-langkah berikut untuk membuktikan bahawa anda adalah pemilik <b>{domain}</b> dan melarang orang lain daripada menggunakan nama domain ini untuk mendaftar akaun syarikat.",
  "082b18ce56": "a. Buka laman web pembekal pengehosan domain dalam <b>tab baharu</b>, kemudian <b>log masuk</b> ke akaun anda;",
  "4f7e0841a9": "b. Di laman web pembekal pengehosan domain, pergi ke <b>bahagian Rekod DNS</b>. Pada halaman web pembekal pengehosan domain anda, nama bahagian Rekod DNS mungkin berbeza, contohnya dipaparkan sebagai <b>DNS Management (Pengurusan DNS), Name Server Management (Pengurusan Pelayan Nama), Control Panel (Panel Kawalan) atau Advanced Setting (Tetapan Lanjutan).</b>",
  "6365ad6e3a": "Seterusnya, <b>kembali ke sini</b>, kemudian klik \"Seterusnya\" untuk menambah rekod pengesahan.",
  "8528892080": "Tambah rekod pengesahan",
  "7a225304f8": "a. Pada halaman DNS, tatal ke bahagian <b>TXT</b>, kemudian klik butang yang berkaitan untuk menambah rekod;",
  "b3cb7d947c": "b. <b>Salin dan tampal</b> semua nilai di bawah ke dalam <b>borang TXT</b> di laman web pembekal pengehosan domain;",
  "47213583bf": "c. <b>Simpan</b> rekod di laman web pembekal pengehosan domain,<br>kemudian <b>kembali ke sini</b>, dan klik \"Sahkan Domain\" di bawah",
  "21486a57cf": "Nota: Dalam medan Nama/Hos/Alias, anda boleh memasukkan \"@\" atau biarkannya kosong. Pembekal pengehosan domain mungkin juga meminta anda memasukkan nama domain (<domain anda>.com) dalam medan ini. Anda mungkin boleh menentukan cara mengisi medan ini berdasarkan rekod DNS lain. Dalam medan Masa untuk Hidup (TTL), masukkan \"86400\" atau kekalkan nilai lalai.",
  "f1b8edab9c": "Tukar Domain",
  "7c6fc663a8": "Sahkan Nama Domain",
  "b6aee9dc0d": "Pengesahan Domain Berjaya",
  "dd4cc429ea": "Telah dibuktikan bahawa anda ialah",
  "450f5c9230": "pemilik, dan melarang orang lain menggunakan nama domain ini untuk mendaftar akaun perusahaan.",
  "71cbcba755": "Klik 'Seterusnya' untuk melengkapkan penciptaan akaun organisasi.",
  "f4084f4870": "Sila tetapkan akaun log masuk anda.",
  "fe3138baec": "Selesai Cipta",
  "0315cddedb": "Organisasi berjaya dicipta.",
  "91454a7f34": "Log masuk ke Konsol Pentadbir sekarang untuk mencipta akaun organisasi untuk ahli-ahli anda.",
  "366304cde7": "1. Akan log keluar secara automatik daripada akaun WPS semasa.",
  "8a9f2a8422": "2. Anda perlu menggunakan akaun organisasi {account}@{domain} untuk log masuk ke Konsol Pentadbir.",
  "43e265e998": "Log masuk ke Konsol Pentadbir",
  "9240efaaf0": "SMS telah dihantar.",
  "e424bb9a6d": "Sila masukkan",
  "d44d581706": "Nama Organisasi",
  "aa8679f406": ", 4~30 aksara",
  "581bdb1f98": ", tidak boleh mengandungi simbol khas \\/:*?\"<>|{}",
  "c13cabb67a": "E-mel",
  "2b9b429e46": "E-mel anda",
  "5ed834a7df": "Sila masukkan e-mel anda.",
  "acfd1f02ed": "Sila masukkan e-mel yang sah.",
  "31c7c92cca": ", maksimum 80 aksara",
  "3f27cf84b3": "Sila masukkan kod pengesahan.",
  "a0ae1f3ec4": "Kod pengesahan tidak betul.",
  "e5589c5e74": "Nama anda",
  "69d7bd63f6": ", hanya boleh memasukkan aksara Cina, huruf, nombor",
  "91f008d258": ", maksimum 8 aksara",
  "6ea6c9b39b": "Nombor telefon",
  "161042c5b7": "Sila masukkan nombor telefon",
  "e6b8eab1cd": "Sila masukkan nombor telefon, 11 digit",
  "3fd5fbb3cc": "Sila masukkan nama domain anda",
  "cb5346ba8e": "Sila masukkan nama domain syarikat yang betul, 4~30 aksara",
  "27928eb7a4": "Akaun",
  "8e19bd444d": "Sila masukkan nama akaun untuk log masuk",
  "7bbbf479dc": "4-20 aksara, hanya digit, huruf atau garis bawah",
  "3d84cae479": "Sila masukkan akaun yang memenuhi syarat / Aksara pertama mestilah huruf atau nombor",
  "c0d5ece1a7": "Kata laluan",
  "f444036fa8": "Sila masukkan kata laluan",
  "b03218d72b": "Kata laluan hendaklah 12-16 aksara, terdiri daripada huruf besar dan kecil, nombor, atau gabungan 3 jenis aksara.",
  "b4ab05df50": "*Seseorang dalam organisasi anda telah menggunakan nama domain anda untuk akaun syarikat. Sila hubungi khidmat pelanggan (400-677-5005) untuk membuktikan pemilikan anda terhadap domain ini.",
  "c58876008f": "Gagal menyalin. Sila cuba lagi.",
  "86f73420de": "Pautan jemputan",
  "a58861962c": "Maaf, pelayar semasa anda tidak menyokong muat turun kod QR ini",
  "228db07f78": "Jabatan Kewangan, Jabatan Jualan, Pengurusan Projek, Data Perniagaan, Jabatan Produk, Jabatan Operasi, Pengurusan R&D, Perancangan Versi, Jabatan Khidmat Pelanggan, Jabatan Pentadbiran, Jabatan Perolehan, Pengurusan Selepas Jualan",
  "93896d7e98": "Selepas mencipta pasukan, mulakan kerjasama dengan rakan sekerja",
  "e8f66fb75c": "Jabatan Kewangan, Jabatan Jualan, Pengurusan Projek/305, Pentadbiran HR/306, Jabatan Operasi, Pengurusan R&D, Perancangan Versi, Pengurusan Khidmat Pelanggan/403, Jabatan Perolehan, Pengurusan Selepas Jualan",
  "831b73da9b": "Nama tidak boleh mengandungi aksara tidak sah dan simbol khas /\\;:*?\"<>|%&",
  "51ab33b3ee": "Parameter tidak betul",
  "a297f9e951": "Nama syarikat bertindih",
  "04d60ed5f5": "Tidak boleh menggunakan perkataan terlarang",
  "2ff7bef083": "Format nama domain salah",
  "41e1ba2165": "Gagal mengesahkan maklumat TXT domain",
  "50f348caa9": "Akaun sudah log masuk",
  "9d4c950d65": "Nama ini telah didaftarkan",
  "38cf19ed95": "Nama organisasi ini sudah wujud",
  "4b426e7c9c": "Nama organisasi",
  "298f880e18": "Sudah wujud, disyorkan anda berikan maklumat lanjut:",
  "1e67dd20b3": "Dapatkan semula nama organisasi",
  "517107cb04": "Gunakan nama lain",
  "5667081882": "Cipta dengan nama ini",
  "e306a979a6": "Isi pantas:",
  "f583db96e0": "*Jika nama organisasi telah digunakan, anda boleh",
  "9767148e34": "Sila masukkan nama syarikat atau organisasi, 4~100 aksara",
  "e0e0ec159f": "Nama organisasi",
  "5b13d254c0": "Nama syarikat ini sudah wujud",
  "92027671ec": "Nama syarikat",
  "36d482a7fb": "Dapatkan semula nama syarikat",
  "79058a7577": "*Jika nama syarikat telah digunakan, anda boleh",
  "c96dd48dba": "Nama syarikat",
  "842efad336": "*Jika anda seorang pekerja syarikat, sila",
  "860f9bd77b": "Hubungi khidmat pelanggan",
  "5a7ed18daf": "Sertai syarikat",
  "ab470e9ace": "Tinggalkan maklumat hubungan",
  "0a7e0e48a7": "Nama syarikat yang memohon untuk menyertai:",
  "a8dc318dcc": "Sila semak maklumat hubungan yang anda isi, khidmat pelanggan platform akan menghubungi anda sebentar lagi.",
  "6ea1f4d7f5": "Hantar Dokumen",
  "d439e39f43": "Dokumen anda telah diterima",
  "884653426b": "Khidmat pelanggan akan menghubungi anda dalam masa 24 jam, sila pastikan anda menjawab panggilan!",
  "2361cb14bf": "Imbas kod QR WeChat untuk menambah khidmat pelanggan dalam talian, dan semak kemajuan.",
  "50f45d0031": "Gagal Menyimpan",
  "fc856d0fd2": "Pentadbir Super",
  "e16c0676d2": "Pentadbir",
  "b1d2ddd126": "Ahli Biasa",
  "9d322cc08d": "Nama organisasi tidak boleh mengandungi simbol khas \\/:*?\"<>|{}",
  "b583ba7363": "Nama syarikat tidak boleh mengandungi simbol khas \\/:*?\"<>|{}",
  "1d118a9bad": "Nama organisasi mesti sekurang-kurangnya 4 aksara, sila masukkan nama organisasi 4~100 aksara.",
  "441b45b1f5": "Nama syarikat mesti sekurang-kurangnya 4 aksara, sila masukkan nama syarikat 4~100 aksara.",
  "97457cb1f0": "Nama organisasi telah melebihi 100 aksara, sila masukkan nama organisasi 4~100 aksara.",
  "8ce00d3b92": "Nama syarikat telah melebihi 100 aksara, sila masukkan nama syarikat 4~100 aksara.",
  "a72778d3de": "Nama mesti sekurang-kurangnya 2 aksara, sila masukkan nama 2~10 aksara.",
  "79c17db5de": "Nama telah melebihi 10 aksara, sila masukkan nama 2~10 aksara.",
  "482a118202": "Nama hanya menyokong aksara Cina, digit, Inggeris, ·",
  "9a9be18941": "Sila tandakan",
  "e6b7c4aa66": "Perjanjian Perkhidmatan Dalam Talian",
  "595023d905": "Cipta Organisasi",
  "ba8c2df551": "Cipta Syarikat",
  "d284384975": "Perjanjian Perkhidmatan Dalam Talian",
  "5c266d5a84": "Dasar Privasi",
  "fcb92dbcf6": "Perjanjian Perkhidmatan Pejabat Awan",
  "2ae7a8a3f7": "Terima kasih kerana memilih Perkhidmatan WPS 365 Cloud Office. Berikut adalah pengenalan utama kepada perjanjian undang-undang antara anda dan/atau organisasi yang anda wakili dengan WPS Office mengenai pendaftaran, langganan, dan penggunaan perkhidmatan ini.",
  "d30a6983bd": "Sila baca {0} | {1} | {2}, klik 'Setuju', ini dianggap sebagai persetujuan anda terhadap kandungan perjanjian tersebut dan menerima perkhidmatan kami.",
  "263e306ede": "Saya telah membaca dan bersetuju dengan {0} | {1} | {2}",
  "440129c0f1": "Sila masukkan {0}",
  "8ab916983d": "Nama organisasi",
  "b01d68543b": "Nama anda",
  "684b30d4e9": "Nombor telefon bimbit anda",
  "a48427e8e2": "Digunakan untuk membina platform kerja milik organisasi anda",
  "3a81b0f1fc": "Memudahkan rakan sekerja mencari anda dalam sistem untuk kerja kolaboratif",
  "52bc539b6e": "Sahkan penciptaan",
  "b2fe245e19": "Cipta organisasi/pasukan: Perkongsian fail dan kolaborasi",
  "893282d3f7": "Sila lengkapkan maklumat organisasi:",
  "cc997bf6aa": "Sahkan",
  "50fdde51ac": "{0}, {1} hingga {2} aksara",
  "a19cc5ec18": "{0}, tidak boleh mengandungi simbol khas \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, hanya boleh memasukkan aksara Cina, huruf, nombor",
  "f4080b1431": "{0}, maksimum {1} aksara",
  "88e59b2d58": "{0}, 11 digit nombor",
  "91d6d4e105": "Sila masukkan kod pengesahan",
  "bec71bde96": "Kod pengesahan tidak betul",
  "e20ff8ee19": "{0} diperlukan",
  "8dc09d10d7": "Tidak dapat mencari dwId",
  "a03766ce6c": "Sekolah",
  "03542addfe": "Organisasi",
  "adb8a815d1": "Pengikatan nombor telefon {0} telah mencapai had.",
  "97a6b66f1d": "Nombor telefon semasa telah diikat pada {0}.",
  "665e465487": "Tidak dapat mencipta {0}, nombor telefon semasa \"<strong>{1}</strong>\" telah mencapai had jumlah ikatan {0} (boleh mengikat sehingga 5 {2}), anda boleh masuk ke {3} yang telah diikat di bawah:",
  "a85b1367ca": "Nombor telefon semasa \"{0}\" telah diikat pada {1}, anda boleh memilih untuk log masuk dengan {2} sedia ada atau mencipta {3} baharu:",
  "bf992ce17b": "Cipta {0} menggunakan nombor telefon lain.",
  "395ea04444": "Cipta {0} baharu.",
  "4ce3bb86b3": "Jumlah {0} yang ditambah melebihi had.",
  "df88c4b7a5": "Nombor telefon semasa \"{0}\" telah mencapai had jumlah ikatan {1}.",
  "78f7dd59ca": "Nombor telefon semasa \"{0}\" diikat pada {1} berikut, boleh terus bertukar untuk digunakan.",
  "8db491a3f8": "Teruskan mencipta {0} baharu.",
  "83f6d9e1e4": "Cuba lagi.",
  "1dc5f11612": "Atau.",
  "217d76f53e": "Maklum balas masalah.",
  "b69a6ea62a": "Sila tekan dan tahan butang kiri tetikus, gosok untuk mendedahkan dua perisai.",
  "3a31f64800": "Tahniah, anda berjaya menggosok keluar perisai<br/>Teruskan ke langkah seterusnya.",
  "6a81fcee96": "Memuatkan.",
  "e97877a65d": "Alamak, perisai hilang<br/>Sila",
  "8d85456145": "Saya sudah menunggu terlalu lama<br/>Sila",
  "77ad847b95": "Rangkaian sangat lemah<br/>Sila",
  "dbd1ae3a34": "Anda menggosok terlalu pantas<br/>Sila",
  "bd8e05cd53": "Klik butang untuk memulakan pengesahan pintar.",
  "63d2a8a722": "Pengesahan berjaya.",
  "73141928ad": "Pengesahan gagal, sila klik butang untuk muat semula.",
  "04856c5c8a": "Pengesanan pintar sedang berjalan.",
  "52cd9bd26d": "Operasi anda tidak dibenarkan.",
  "fd157e8ea8": "Cipta Panduan",
  "c6225c5b2b": "Selamat Datang ke Versi Perusahaan",
  "e33423fb1e": "Berjaya Dicipta",
  "7b0c035999": "Halaman Kejayaan Penciptaan Organisasi WPS Docs",
  "85db8faae0": "Arahan Penggunaan Versi Perusahaan",
  "20591b9b44": "Pulihkan Nama Organisasi",
  "b023d76dc2": "Panduan Muat Naik Ahli",
  "e2f454e095": "Perusahaan {0}",
  "df466f942b": "Cawangan",
  "26a7b797c4": "Sub-pusat",
  "5fc82b360b": "Platform perkhidmatan pejabat sehenti, menjadikan kerja anda lebih cekap",
  "f2e736d52e": "Selamat Datang ke Versi Perusahaan",
  "becc41a35b": "Nama Organisasi",
  "74685cdc58": "Sila masukkan nama perusahaan atau organisasi, 4~100 aksara",
  "07b55b1907": "Saiz Organisasi",
  "77b2f763ad": "Sila pilih saiz organisasi anda",
  "49d2509109": "Kurang daripada 5 orang",
  "8db2c9b74a": "6-20 orang",
  "a9fb0cf14a": "21-50 orang",
  "0fed41f8d3": "51-100 orang",
  "fb33f25a04": "101-200 orang",
  "3e3ff0f52e": "201-500 orang",
  "cd8b51f634": "501-2000 orang",
  "0662fa6eec": "Lebih daripada 2000 orang",
  "69334dba1a": "Keperluan Perusahaan",
  "79994e749c": "(Kami akan mengesyorkan penyelesaian amalan industri terbaik untuk organisasi)",
  "840a017f38": "Sila pilih masalah yang paling ingin anda selesaikan",
  "f045b05c73": "Sila masukkan keperluan anda untuk penciptaan organisasi",
  "d8efb0b36d": "Lain-lain",
  "adcb8fbb0c": "Nombor telefon bimbit utama",
  "eb1c73e2ca": "Sila masukkan nombor telefon bimbit 11 digit anda yang kerap digunakan",
  "7f276e7dfa": "Cipta secara percuma",
  "c391b3eec1": "Gagal menghantar SMS",
  "54f4cb8fa7": "SMS telah dihantar",
  "231eb1fa1e": "Pengguna Organisasi_{0}",
  "272b0f9d32": "Pengguna Organisasi",
  "b209a67331": "Gagal mencipta organisasi, sila muat semula halaman.",
  "acb08d0cc9": "Langkah ketiga penciptaan organisasi",
  "83db361f51": "Selepas penciptaan selesai, picu logik pengalihan",
  "1e930326e3": "handleStep ke langkah seterusnya",
  "184df5c725": "saveForm gagal",
  "736eab3023": "Serah pengesahan",
  "2db62dc13c": "Pengesahan gagal",
  "54fb0afaea": "Pengesahan berjaya",
  "d39cff3fcf": "Melangkau penyimpanan ekstrem hanya untuk mendapati kod pengesahan diperlukan",
  "305b777ae5": "Gagal menyemak nama. Dayakan tetingkap timbul \"Nama organisasi telah digunakan\" dan simpan nama",
  "e57b6686b2": "Semak sama ada subjek pengesahan telah disahkan. Dayakan tetingkap timbul gesaan perlindungan pengesahan & simpan maklumat subjek pengesahan yang berkaitan",
  "f7c86f496d": "Penciptaan nama duplikat || Kod pengesahan tamat tempoh. Jika mana-mana daripadanya tidak lulus, halang pelaksanaan",
  "cb37db4fd4": "handleSubmit gagal",
  "243a569fc4": "Nama ini telah didaftarkan, sila gunakan nama lain",
  "196851a3d9": "Pengguna Organisasi_{0}",
  "0c3a3595ff": "Pengguna Organisasi",
  "a33b41e0f2": "Gagal membuat organisasi, sila muat semula halaman.",
  "fcce6a7156": "Berjaya Dicipta",
  "5ec6da58a6": "Maklumkan Klien",
  "259c9dfa4e": "Logik Versi Profesional",
  "864156930f": "Logik VBA",
  "7824efd172": "WPS Docs Mudah Alih",
  "52b6cfaaaf": "Klien WPS",
  "c7c51beea9": "Versi Pendidikan",
  "8d054d4986": "Klien Lalai",
  "b597e18fb1": "isWps365PcClient dan mempunyai openurl",
  "b0c13de2a0": "isWps365PcClient atau bukan klien, mempunyai openurl",
  "7d0f2ce18c": "isWps365PcClient atau bukan klien, mempunyai panggilan balik openurl success",
  "e2c5a07df6": "Bukan klien bukan openurl",
  "29e0414d1f": "Bukan klien bukan panggilan balik openurl",
  "60861f7d2a": "autoChange diserahkan kepada pihak perniagaan untuk beralih sendiri",
  "7c83140d90": "Penciptaan status pelawat, tidak perlu menukar akaun melalui SDK (SDK tidak menyokong pelawat), kod telah berjaya ditukar melalui antara muka.",
  "3379b09e59": "Mempunyai openurl dan menggunakan href untuk beralih",
  "586ff04c22": "Lompat Secara Berasingan",
  "b6c91f218b": "useSuccessSkip gagal",
  "47d2f3ba66": "Lain-lain",
  "57551f86ce": "Mencetuskan kaedah lompat yang berbeza berdasarkan utm_source",
  "64fe3758e2": "Operasi anda tidak dibenarkan.",
  "4da3e1262f": "Berjaya dicipta, mulakan perjalanan pejabat organisasi anda.",
  "c38dfb8c6c": "Cipta pasukan pertama anda",
  "38dddb483b": "Masuk Organisasi",
  "614d9c91eb": "Jemput ahli untuk menyertai",
  "97f1eca0aa": "Masuk Organisasi",
  "13a4939e90": "Sertai jemputan organisasi",
  "a319e4ae0a": "Jemput rakan sekerja untuk menyertai",
  "12e4da6bba": "Jemput rakan sekerja sekarang",
  "bd885380f6": "Gagal mendapatkan pautan jemputan",
  "5e626c4063": "SMS telah dihantar",
  "3dc09e7cfd": "Bilangan nama organisasi yang anda mohon untuk dapatkan semula telah mencapai had",
  "48318f41f9": "Jemput ahli untuk menyertai",
  "45441baac4": "Jemput anda untuk menyertai {0} untuk bekerjasama",
  "e5847fbd67": "Salin pautan, jemput ahli",
  "23101dd40a": "Sedang menyesuaikan penyelesaian untuk anda",
  "71bb7e54a8": "Pengurusan Projek",
  "aff37c79cc": "Alami pelan yang dipilih",
  "a97b174258": "Jemput lagi <color: red>2</> rakan sekerja untuk menyertai, dapatkan faedah perusahaan berikut secara percuma",
  "253855849f": "Kongsikan pautan jemputan ke kumpulan kerja anda untuk menjemput rakan sekerja",
  "57b0a2a63f": "Salin pautan, jemput rakan sekerja",
  "71c0a37ee1": "Masuk Organisasi",
  "f848c60e0e": "Jemput lagi <color:red>2</> rakan sekerja untuk menyertai, dapatkan faedah perusahaan berikut secara percuma",
  "664e32b4fe": "Halaman Jemputan Masuk Organisasi",
  "872f14403a": "Jemput rakan sekerja untuk menyertai",
  "1880e7deb9": "Jemput rakan sekerja sekarang",
  "cc2a9aaf82": "Berjaya Dicipta",
  "02a13e2583": "Jemput lagi <color: red>2</> rakan sekerja untuk menyertai, dan dapatkan faedah korporat berikut secara percuma",
  "5d3593cdce": "Gagal mendapatkan maklumat pasukan",
  "c025113ea1": "Gagal mendapatkan pautan jemputan",
  "b83bc1e485": "Jemput melalui Pautan",
  "0996ced9f6": "Maaf, pelayar semasa anda tidak menyokong muat turun kod QR ini",
  "1e88451e31": "Pautan jemputan telah disalin",
  "bb969cabcd": "Gagal menyalin, sila cuba lagi",
  "15e1f79c7a": "Mohon untuk menyertai organisasi",
  "59c22b4ef8": "Menerima pautan jemputan",
  "0f0b392e60": "Cipta Pasukan Pertama Anda",
  "0437d07c43": "Nama Organisasi",
  "41800c7bf1": "Sila masukkan nama pencipta",
  "1ec5999511": "Nama pencipta maksimum 8 aksara",
  "02da35b4e4": "Nama pencipta hanya boleh mengandungi aksara Cina, huruf dan angka",
  "184e9f6616": "Sila masukkan nombor telefon",
  "9b587898ba": "Sila masukkan nombor telefon dalam format yang betul",
  "e68c164a02": "Sila masukkan e-mel anda",
  "0b1de22df7": "Sila masukkan e-mel dalam format yang betul",
  "61026181ab": "Lesen perniagaan wajib diisi",
  "c3847e604e": "Saiz fail melebihi 10MB, sila pilih semula",
  "49450f4ec7": "Borang rayuan nama duplikat wajib diisi",
  "39c3b8fa1d": "Penyerahan gagal",
  "3ea44d7963": "Muat naik berjaya",
  "5b1aa3c2c4": "Muat naik gagal",
  "7e7f81eaa3": "Muat naik gagal, saiz fail melebihi 10MB",
  "2ff1913de1": "Muat naik gagal, fail mestilah .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "Lesen perniagaan wajib diisi",
  "66bda65057": "Saiz fail melebihi 10M, sila pilih semula",
  "8f2305a83d": "Borang rayuan nama bertindih wajib diisi",
  "55ff0c8c6e": "Penghantaran gagal",
  "8dad6d950d": "Gagal mendapatkan maklumat jemputan",
  "a5f0ac3a9a": "Berjaya dicipta",
  "4f1d069770": "Parameter utm untuk akses halaman jemputan ialah {0} dan nama {1}",
  "f9578cfe6d": "Parameter utm untuk akses panduan dua langkah ialah {0} dan nama {1}",
  "e10d028405": "Panduan dua langkah pcoffice created",
  "8e22e4fcc4": "Pautan jemputan telah disalin",
  "3f327f9f37": "Salin gagal, sila cuba lagi",
  "bd1aecb265": "Batal",
  "b6abf9b19a": "Setuju",
  "e910d9cc0f": "Batal",
  "37ab25522d": "Setuju",
  "196b3eb9cf": "Imbas kod untuk sertai",
  "2b81c52e20": "Muat turun imej",
  "62152fd9f3": "Jemput melalui pautan",
  "e0a3725651": "Maaf, pelayar semasa anda tidak menyokong muat turun kod QR ini",
  "8b7883b2c7": "Imbas kod untuk sertai",
  "9e9a659ed5": "Muat turun imej",
  "0d55065a9a": "Jemput melalui pautan",
  "487cf6a106": "Maaf, pelayar semasa anda tidak menyokong muat turun kod QR ini",
  "78fd005d1f": "Sila masukkan nombor telefon",
  "f909563857": "Cipta menggunakan nombor ini",
  "a26a19f139": "Batalkan penciptaan",
  "cc004ac9ee": "Nombor Telefon",
  "4df8c3c588": "Masukkan nombor telefon lain untuk cipta sekolah",
  "3151cabb3d": "Masukkan nombor telefon lain untuk cipta perusahaan",
  "56098a71eb": "Klik pengesahan pintar, hantar kod pengesahan",
  "e96ec218e4": "Sila masukkan kod pengesahan SMS",
  "ce619a0225": "Kod pengesahan SMS dihantar ke",
  "0e9863aaeb": "Kod pengesahan salah, sila masukkan semula",
  "32dc8629e1": "Hantar semula selepas ... saat",
  "e4eda9add5": "Hantar Semula",
  "b007977564": "Gagal mendapatkan maklumat kelulusan",
  "d8852ffc9c": "Akses bukan pentadbir",
  "8a733a2574": "Akses mudah alih",
  "9e8c152c4f": "Akses PC",
  "2265a55e93": "Setuju dengan perjanjian perkhidmatan",
  "80dabe5aa3": "Cipta panduan",
  "7deee8bf5a": "Panduan dua langkah docsWeb created",
  "69eb501ecb": "Rayuan anda telah tamat tempoh dan tidak boleh diakses",
  "aa1d9d98ad": "Kebenaran tidak mencukupi, tidak boleh diakses",
  "fdf2fe129e": "Cipta organisasi",
  "7f0ca0df6b": "Cipta perusahaan",
  "cc6ac2a93c": "Panduan dua langkah Base mounted",
  "5d6c570bf0": "Panduan dua langkah beforeunload",
  "a4eb8a192d": "Pasukan yang sedang dicipta oleh semua orang",
  "4912e16a9d": "Nama organisasi telah ditemukan semula",
  "41c4e87ef2": "Anda boleh klik pautan",
  "5e630930c0": "Cipta semula organisasi",
  "436a563524": "Jika anda telah mencipta organisasi, anda boleh merujuk",
  "0b6e7cbe7f": "“Cara Mengubah Nama Organisasi”",
  "cb7bce0775": "ubah nama organisasi melalui tutorial",
  "3feadd3040": "Versi semasa terlalu rendah, tidak dapat menggunakan organisasi",
  "3cf23de936": "Versi perisian anda terlalu rendah, ciri organisasi tidak dapat digunakan. Sila ke gedung aplikasi untuk mengemas kini versi perisian anda!",
  "a1c5d5d202": "Faham",
  "e50183bd00": "WPS Dokumen Awan",
  "e5031ab679": "Keselamatan, Segerak, Kerjasama",
  "c870026dfc": "Log masuk dengan WeChat",
  "e7647cd875": "Nombor telefon atau E-mel",
  "07b380074b": "Log masuk dengan QQ",
  "67921724dd": "Kaedah lain",
  "254da8a9f5": "Jumlah organisasi yang disertai/dicipta telah mencapai had",
  "3648e4811b": "Masuk ke WPS Docs",
  "dcd102b346": "Cipta pasukan tersuai",
  "8b9b258cbf": "Masukkan nama pasukan di sini",
  "19bb6e0ded": "Ahli WPS menikmati",
  "2d9fe8d938": "pelbagai keistimewaan pejabat, membantu anda menyelesaikan masalah dokumen dalam kerja pejabat harian, mari alami sekarang!",
  "e8c1caa649": "Muat naik dari tempatan",
  "03641083a3": "Pindahkan dari “Dokumen Peribadi”",
  "eecd3ab9b5": "Lain kali",
  "13b447b3a8": "Segarkan semula",
  "3c2fc507fc": "Versi semasa terlalu rendah untuk menggunakan ciri organisasi",
  "c3615d8134": "Versi perisian anda terlalu rendah untuk menggunakan ciri organisasi. Sila lawati laman web rasmi untuk mengemas kini versi perisian anda!",
  "644a36e05b": "Kemas Kini Sekarang",
  "d435105f21": "Bilangan organisasi yang boleh disertai/dicipta telah mencapai had maksimum",
  "73a286ceb0": "Pergi ke WPS Docs",
  "c2cec645c0": "Batal",
  "b5f5b83c0f": "Setuju",
  "76ec352da5": "Jemput rakan sekerja dengan mengimbas kod",
  "6a509e4487": "Muat Turun Kod QR",
  "940cc4a546": "Tidak dapat mencipta organisasi",
  "78b2a62ea5": "Masuk ke organisasi sedia ada atau cipta organisasi baharu",
  "3a6da7f6f9": "Nombor telefon semasa telah mencapai had maksimum bilangan organisasi yang terikat (maksimum 5 organisasi).",
  "93bab52870": "Nombor telefon semasa telah diikat dengan organisasi, anda boleh memilih organisasi sedia ada untuk log masuk:",
  "ce6e0adaf2": "Anda boleh memilih untuk masuk ke organisasi yang telah diikat di bawah:",
  "1ce200a92b": "Pilih",
  "bb91ef2999": "Cipta organisasi baharu",
  "024e4a91e5": "Nama organisasi telah didaftarkan",
  "eb089a23a0": "Nama organisasi ini telah didaftarkan:",
  "7646558701": "Pentadbir:",
  "1d9c02bd33": "Masa pendaftaran:",
  "919fc7805f": "Anda disyorkan untuk cuba mencari dan menghubungi rakan sekerja anda yang disebutkan di atas.",
  "0ca71a9344": "Anda juga boleh menggunakan nama lain buat sementara waktu untuk mencipta organisasi (yang boleh diubah kemudian), kemudian hantar aduan.",
  "e83a244e90": "Klik untuk mengetahui cara membuat aduan.",
  "d22bedfb21": "Sahkan",
  "907b78b6e5": "Masukkan nama kumpulan kerja atau pasukan",
  "7195b0ac1e": "Pasukan yang mungkin ingin anda cipta",
  "60ed4f915e": "Seterusnya",
  "f5ba8dfb7b": "Langkau Panduan",
  "5c44a3ef68": "Sehingga 100 aksara",
  "130c53fb20": "Nama tidak boleh mengandungi aksara tidak sah dan simbol khas /\\;:*?\"<>|%&",
  "e832d41acc": "Panduan Dua Langkah Langkau",
  "80d9cf7177": "Panduan Dua Langkah Muat Semula",
  "0aebf80435": "Panduan Dua Langkah Klik label",
  "e74f515977": "Panduan Dua Langkah handleSubmit",
  "308d2a53c9": "Panduan Dua Langkah createGroup",
  "dda2ed7e18": "Panduan Dua Langkah Gagal mencipta pasukan",
  "ded3c35500": "Gagal mencipta pasukan",
  "4f18031bc1": "Panduan Dua Langkah createTemplate",
  "091e5cefcc": "Panduan Dua Langkah createTemplate ralat",
  "58cf4e00f0": "Kod pengesahan",
  "92abbf0385": "Hantar Kod Pengesahan",
  "f0f9976ef9": "Sila masukkan nombor telefon",
  "a4ce99b1df": "Kod pengesahan",
  "39d36e0f9f": "Sahkan",
  "0fd8a01938": "Hantar",
  "9048a4e842": "Nombor Telefon",
  "9afa1091eb": "Hantar Semula",
  "58d787001f": "Masukkan nombor telefon lain untuk mencipta sekolah",
  "450905a265": "Masukkan nombor telefon lain untuk mencipta syarikat",
  "f7386de3c6": "Pilihan juntai bawah",
  "27aa05a92c": "Setuju Perjanjian Perkhidmatan",
  "80af61cb57": "Kembali ke halaman sebelumnya",
  "50149b8d4f": "Nama pemohon",
  "e6756f8749": "Sila masukkan nama anda",
  "3cbd51a2b1": "Nama mestilah sekurang-kurangnya 2 aksara. Sila masukkan nama 2-10 aksara.",
  "4f79b4813f": "Nama hanya menyokong aksara Cina, digit, Inggeris,",
  "71d3e75983": "Nombor telefon bimbit utama",
  "afe5149035": "Sila masukkan nombor telefon bimbit utama anda",
  "1e9270b50f": "Sila masukkan nombor telefon bimbit utama anda, 11 digit.",
  "ff5dc98dfb": "Langkau",
  "165be2ab43": "Kembali ke langkah sebelumnya",
  "231d8a335a": "Setuju Perjanjian Perkhidmatan",
  "1cad008ffc": "Nama syarikat {0} telah didaftarkan, sila gunakan nama lain.",
  "c6e274fcab": "Pengesahan perjanjian",
  "b9352504bb": "Tutup tetingkap timbul perjanjian",
  "8409e99ad0": "Buka tetingkap timbul perjanjian",
  "1593c6dd95": "Hantar",
  "4f44a9de22": "Buka pengesahan SMS",
  "26b70c68b8": "Langkau, terus ke organisasi.",
  "a8bebcb302": "Kembali ke halaman sebelumnya",
  "c800b4fec5": "Halaman jemputan Base Mounted",
  "38b396d5b0": "Halaman jemputan docsWeb Mounted",
  "2eb7f9a9f1": "Aduan anda telah berjaya dihantar.",
  "2c6f3590fb": "Kami menjangkakan akan menghantar hasil pemprosesan ke e-mel anda dalam tempoh 3 hari bekerja.",
  "2ea3eff708": ", sila semak.",
  "53acfba22c": "Segera jemput rakan sekerja",
  "4e6d282f4f": "Sertai jemputan organisasi",
  "5f72f4b936": "Segera jemput rakan sekerja",
  "e5383077ba": "Pulihkan Nama Organisasi",
  "06e3fa2350": "Setelah disemak,",
  "653a263b5e": "Penciptanya ialah",
  "769f57269f": "Nombor telefon bimbit pencipta ialah",
  "09a224695e": "Sila sahkan sama ada pencipta organisasi ini adalah rakan sekerja anda",
  "3beda6c149": "·Jika dia rakan sekerja anda, anda boleh menghubunginya",
  "5c74dd10d1": "Ubah nama organisasi atau pindahkan pentadbir super.",
  "da504edb0f": "·Jika dia bukan rakan sekerja anda, anda boleh klik butang di bawah untuk terus memulihkan nama organisasi.",
  "39194faaf1": "Teruskan memulihkan nama organisasi",
  "e22b829e90": "Berjaya disalin",
  "6e1b44752a": "Nilai TXT",
  "79881b1d7a": "Segera jemput rakan sekerja",
  "a5344a45f9": "Klik penjuru kanan atas, dan pilih [Hantar kepada Rakan]",
  "a4954a5b08": "Segera jemput rakan sekerja",
  "8e3a1625fb": "Pulihkan Nama Organisasi",
  "bf8b8c7005": "Muat naik lesen perniagaan organisasi",
  "bfd44a66c9": "Klik untuk memilih",
  "d503f20925": "Sila muat naik salinan imbasan atau foto lesen perniagaan organisasi",
  "cbebe043c5": "Menyokong format JPG, JPEG, PNG, BMP, PDF, saiz tidak melebihi 10 MB.",
  "9650b96d7d": "Muat naik borang maklumat rayuan nama bertindih",
  "c3b8ae46d3": "Sila muat naik salinan imbasan atau foto borang maklumat rayuan nama bertindih",
  "9e325a9e09": "Muat turun templat borang maklumat",
  "a4711aae88": "Hantar Permohonan",
  "3a5cc1441e": "Mengesahkan...",
  "0bd7bf8511": "Kami tidak dapat mengesahkan domain anda pada masa ini. Anda mungkin perlu menunggu sebentar lagi untuk pembekal perkhidmatan pengehosan domain anda mengemas kini maklumat anda. Jika masih tiada respons selepas beberapa ketika, sila cuba sahkan semula, atau tukar domain anda.",
  "fae48d554b": "Menyemak domain",
  "5e1779a0ca": "rekod pengesahan, anda boleh menutup halaman ini dan kembali semula nanti untuk menyemak.",
  "ca85f8b836": "Selamat datang ke Versi Perusahaan",
  "2570e0f00b": "Log masuk gagal",
  "40d16a007e": "Akaun peribadi anda telah dipautkan secara automatik",
  "81376b92e4": "Cara log masuk {0}, sila log masuk semula untuk menukar akaun syarikat.",
  "ba679ba739": "Faham, ke log masuk",
  "c05f64c6c6": "Secara automatik ke log masuk selepas {0}",
  "c329ccef3a": "Log masuk gagal",
  "e370f9afb1": "Akaun peribadi anda telah dipautkan secara automatik",
  "410cf42585": "cara log masuk, sila log masuk semula untuk menukar akaun syarikat.",
  "062d48aece": "Faham, ke log masuk",
  "95a105d412": "selepas secara automatik ke log masuk",
  "2d000d5a6d": "Hantar pautan kongsi kepada ahli, ahli boleh memohon untuk menyertai selepas dibuka",
  "8861b6e90d": "Masuk Syarikat",
  "25b9f72fda": "Ralat parameter halaman",
  "1c76123efc": "Gagal mendapatkan pautan jemputan",
  "6caba48b76": "Langkau",
  "f66379c650": "Ralat parameter halaman",
  "c45021de2a": "Gagal mencipta",
  "011d470126": "Platform secara berterusan melindungi keselamatan maklumat anda",
  "f1a44d9151": "Platform telah memperoleh sijil ISO27001 dan ISO27701 yang dikeluarkan oleh BSI antarabangsa, dan telah lulus penilaian kelayakan keselamatan perlindungan siber peringkat 3 kebangsaan--",
  "255ea5dff7": "Kertas Putih Keselamatan",
  "bb55b124f2": "Cipta Persembahan Syarikat",
  "61e24974a3": "Cipta syarikat untuk mendapatkan kandungan dasar",
  "bfdf78febe": "Langkah seterusnya, lengkapkan maklumat",
  "c4aa2d2d60": "Masukkan nama kumpulan kerja atau projek",
  "b69765ab64": "Pasukan yang sedang dicipta oleh semua orang",
  "9657d9408b": "Muat semula",
  "e21da8c16a": "Langkah Seterusnya",
  "224ef5cc9f": "Langkau Panduan",
  "641f58c8f6": "Organisasi semasa tidak menyokong ahli untuk membuat pasukan. Sila hubungi pentadbir untuk membuatnya.",
  "efea622752": "Salin pautan dan jemput rakan sekerja.",
  "fd5b40a9fd": "Anda dijemput untuk menyertai '{0}' dan bekerjasama.",
  "b04dd2f10a": "Pautan jemputan telah disalin.",
  "d1606a1b1a": "Gagal menyalin. Sila cuba lagi.",
  "0d59f3db83": "Masukkan jabatan projek atau pasukan, contohnya 'Jabatan Jualan'.",
  "9429513d34": "Tidak memerlukan panduan.",
  "b54a20b1ff": "Gagal membuat.",
  "093fa0fb74": "Sedang log masuk dan memberi kebenaran...",
  "b383b136f4": "Penciptaan dan inisialisasi projek organisasi.",
  "b6b21b388b": "Nama organisasi telah didaftarkan.",
  "285dc68c10": "Nama organisasi ini telah didaftarkan:",
  "1bf685b89d": "Pentadbir:",
  "7b4297edcc": "Masa pendaftaran:",
  "fa51ea19fc": "Anda disyorkan untuk cuba mencari dan menghubungi rakan sekerja anda yang tersebut di atas.",
  "e3678a996d": "Anda juga boleh menggunakan nama lain buat sementara waktu untuk membuat organisasi (boleh diubah kemudian), kemudian hantar aduan.",
  "5969bc8071": "Baik.",
  "ba4cf699df": "Pulihkan Nama Organisasi.",
  "afecee4eb4": "Nama Anda",
  "a8bdebc614": "Sila masukkan nama anda.",
  "5bbeb38a66": "Nombor Telefon",
  "b4f7b44b7a": "Sila masukkan nombor telefon anda.",
  "cac2913686": "E-mel Hubungan",
  "23d3bb3a42": "Sila masukkan e-mel hubungan anda.",
  "ea106a393c": "Muat naik lesen perniagaan syarikat",
  "f74131d71e": "Klik untuk memilih",
  "53749c51c5": "Sila muat naik salinan imbasan atau foto lesen perniagaan syarikat",
  "c00f2ea171": "Menyokong format JPG, JPEG, PNG, BMP, PDF, saiz tidak melebihi 10 MB.",
  "57ec07fa97": "Muat naik borang maklumat rayuan nama bertindih",
  "8eb0606e94": "Sila muat naik salinan imbasan atau foto borang maklumat rayuan nama bertindih",
  "f59e76c0b0": "Muat turun templat borang maklumat",
  "030bd26fa4": "Hantar permohonan",
  "0a602dc727": "Penyimpanan data yang selamat",
  "9138f28acf": "Perkongsian dan kolaborasi fail",
  "b3a306cf90": "Pematuhan dan pelesenan sah",
  "973c53f725": "Cadangan untuk mengubah nama. Selepas pendaftaran, anda boleh menghantar pengesahan organisasi dan mengemas kini nama.",
  "f886f5e92f": "Cadangan untuk mengubah nama. Selepas pendaftaran, anda boleh menghantar pengesahan syarikat dan mengemas kini nama.",
  "b8051702a3": "Nama ini mengandungi perkataan sensitif. Sila laraskan nama atau hubungi khidmat pelanggan.",
  "d73881f7d4": "Nama syarikat dilindungi",
  "dc7e58e320": "Nama syarikat dilindungi. Pengesahan maklumat entiti diperlukan sebelum penggunaan. Cadangan untuk mengubah nama syarikat, atau menggunakannya selepas pendaftaran melalui pengesahan syarikat.",
  "20c3bc070c": "Sahkan",
  "c4278e5f28": "Kebenaran tidak mencukupi",
  "9217efae21": "Akaun yang anda log masuk tiada kebenaran untuk mencipta. Sila hubungi kakitangan jualan untuk bantuan.",
  "52ff08f2ad": "Nama institusi dilindungi, sila laraskan nama syarikat.",
  "79386ae280": "Sila masukkan kod pengesahan 6 digit",
  "d7b2c5a41b": "Kod pengesahan telah dihantar ke",
  "ce2e1c26f7": "(Sah dalam tempoh 10 minit)",
  "59d338903f": "Boleh mendapatkan semula kod pengesahan selepas {0} saat",
  "5aadd14136": "Dapatkan semula kod pengesahan",
  "90f5c93432": "Nama ini sudah didaftarkan",
  "1677072f4a": "Anda boleh menambah maklumat lanjut, atau mendaftar dengan nama lain.",
  "3b8459fb1e": "Isi Pantas:",
  "6f38edbcb1": "Daftar dengan nama ini",
  "8406c81e2d": "Cawangan",
  "29d323fa85": "Sub-pusat",
  "4f0e806e02": "Jabatan Kewangan",
  "3f935efb6b": "Setuju dengan perjanjian perkhidmatan",
  "b42241be05": "Nanti",
  "99de4b33b7": "Setuju",
  "7f867e7395": "Cipta organisasi dengan nombor telefon lain",
  "0d51a8f7a6": "Teruskan Penciptaan",
  "8bdaecf2e5": "Sila masukkan nombor telefon anda",
  "565ae60c8a": "Sila masukkan nama anda",
  "f76e06d0e7": "Sila masukkan nombor telefon anda",
  "7b0fca5255": "Sila masukkan kod pengesahan",
  "68026d2d25": "Selamat datang ke Edisi Perusahaan",
  "d25b5541be": "Cipta secara percuma",
  "32cfd73733": "Sila masukkan nama pasukan, perusahaan, atau organisasi anda",
  "4cf83dc4a0": "Cipta dengan pantas dalam satu minit, dan bekerjasama dengan cekap bersama rakan sekerja",
  "d320d37116": "Cipta pasukan/perusahaan secara percuma",
  "c54b475dd2": "Perjanjian Pengguna",
  "190d54e616": "Perusahaan {0}",
  "8c1b768ac4": "Pengesahan pintar gagal",
  "d74eab0f35": "Maklumat nama perusahaan yang anda masukkan tidak mematuhi spesifikasi platform, sila ubah suai dan cuba lagi.",
  "0f3d62dd4f": "Maklumat nama yang anda masukkan tidak mematuhi spesifikasi platform, sila ubah suai dan cuba lagi.",
  "647cf2211b": "Nombor telefon bimbit semasa tidak disokong untuk pendaftaran, sila tukar nombor telefon bimbit.",
  "b63d96cdae": "Maklumat yang dimasukkan tidak mematuhi spesifikasi platform, sila ubah suai dan cuba lagi.",
  "2dbbe8e43f": "Nombor telefon bimbit semasa tidak disokong untuk pendaftaran, sila ubah suai dan cuba lagi.",
  "b18abc5de6": "Nombor telefon bimbit tidak terikat.",
  "f5233dae6f": "Sila tukar nombor telefon bimbit untuk pendaftaran.",
  "4167c8b88d": "Nombor telefon bimbit semasa mungkin menghadapi situasi berikut, sila cuba tukar nombor telefon bimbit untuk pendaftaran. Jika ada pertanyaan, sila hubungi khidmat pelanggan.",
  "a8a2433c4d": "Imbas kod WeChat untuk menambah, hubungi khidmat pelanggan untuk pertanyaan.",
  "444a639c09": "Saya faham.",
  "69a097057f": "Nombor telefon bimbit semasa tergolong dalam <#BB2726>segmen nombor pengendali maya<#BB2726>.",
  "4370b06fd0": "Nombor telefon bimbit semasa mempunyai <#BB2726>tingkah laku penggunaan yang tidak normal<#BB2726>.",
  "8c49e1dc4a": "Perlu melakukan pengesahan manusia-mesin.",
  "4b8ba7d8cc": "Platform Produktiviti Berkualiti Baharu Pejabat.",
  "81be771e17": "🎉Penciptaan syarikat berjaya! Lengkapkan maklumat untuk mendapatkan perkhidmatan eksklusif.",
  "461125b057": "Boleh mengurus dokumen dan bahan dalam pasukan. Ahli pasukan boleh melihat dengan mudah, dan juga boleh menetapkan kebenaran seperti edit/muat turun, memastikan keselamatan data.",
  "c3eb25029b": "Saiz syarikat/pasukan anda.",
  "049f8401ec": "Kurang daripada 5 orang.",
  "c81896349e": "6-20 orang.",
  "7357daac4e": "21-50 orang.",
  "f0e65a0a29": "51-100 orang.",
  "b9fac8204a": "101-200 orang.",
  "62d73dddaf": "201-500 orang.",
  "3bcdaf7160": "501-2000 orang.",
  "ab0b2333fe": "Lebih daripada 2000 orang.",
  "4f756eedc8": "Peranan anda ialah",
  "3ba0b502c3": "Pengurus Besar",
  "702099cc72": "Kewangan",
  "843b603162": "Perolehan",
  "8b414a9b44": "Sumber Manusia/Pentadbiran",
  "92486b2908": "Jualan",
  "ac4e7fb063": "Adakah organisasi anda mempunyai bajet/pelan perolehan perisian pejabat?",
  "37634c72dc": "Dalam tempoh enam bulan",
  "bd94b6deec": "Dalam tempoh 1 tahun",
  "713f4aad5c": "Sedang mempertimbangkan",
  "c5ea095a4d": "Tiada rancangan buat masa ini",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Cipta pasukan, jemput ahli untuk bekerjasama",
  "9d27dc2d90": "Boleh masukkan nama pasukan anda atau projek yang baru diikuti",
  "de19c8509a": "Anda mungkin ingin mencipta:",
  "1a84699223": "Jabatan Jualan",
  "efab59502b": "Jabatan Produk",
  "7e599b3713": "Jabatan Operasi Selatan",
  "bf494779c2": "Jabatan Perolehan",
  "f3a60ab34d": "Jabatan Pentadbiran",
  "bbc50c1ac8": "Jabatan Kewangan Utara",
  "32629e3dac": "Jabatan Kewangan Produk",
  "5524d354ba": "Jabatan IT",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>Anda telah membuka kunci faedah pengguna baharu!</span> Jemput lagi 3 orang untuk mendapatkan faedah <span style='color: rgb(206,131,62);'>ruang 4T, WPS AI</span>.",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Anda telah membuka kunci had 50 orang, faedah muat naik fail tunggal maksimum 4G</span>. Teruskan menjemput 3 orang untuk menyertai, buka kunci faedah bernilai hebat 30 hari WPS AI, ruang 4T.",
  "136c26d941": "Salin pautan di bawah, jemput ahli untuk menyertai.",
  "3de5c12558": "Salin pautan, jemput rakan sekerja.",
  "a5d64b14f3": "Panduan Maklumat Perusahaan",
  "b8f2492701": "Pengumpulan Maklumat Perusahaan",
  "1f9d053dc0": "Cipta Templat Pasukan",
  "0e83c79a88": "Jemput Ahli",
  "821fc1906a": "Masuk Organisasi",
  "463e14ae9c": "Sila Pilih Pasukan",
  "690f0cdb9e": "Ikon Selesai",
  "c340522a17": "Sebelumnya",
  "f9355c72ef": "Langkau",
  "bd6c09ebbb": "Seterusnya",
  "2a2603cd3f": "Imbas kod QR untuk hantar jemputan kepada rakan sekerja",
  "411e64907a": "Salin",
  "b0d988cf23": "Muat Turun",
  "e3c0b650ac": "Berjaya Disalin",
  "713ac624b4": "Selamat Datang ke WPS 365",
  "b8fff97849": "Elemen Sasaran Tidak Sah",
  "02acdcf296": "Penukaran html2canvas gagal, kanvas tidak dijana",
  "a76988c496": "Penukaran kanvas kepada blob gagal",
  "af89584edf": "API Papan Keratan Tidak Tersedia",
  "f90263bbde": "Gagal Menyalin Imej",
  "71b05319da": "Penukaran HTML ke kanvas gagal",
  "38852999fe": "Gagal Menyimpan Maklumat",
  "4a4c621d07": "Gagal Mencipta Pasukan, sila cuba lagi nanti",
  "d239a23994": "Halaman ini hanya boleh diakses oleh akaun perusahaan, sila log masuk dengan akaun perusahaan terlebih dahulu.",
  "d93bfb7fb9": "Sila Masukkan Kandungan",
  "42b81a66c4": "Panjang mestilah 2 hingga 100 aksara.",
  "76d33733db": "Tidak boleh mengandungi aksara khas seperti / \\ ; : * ? \" < > | % &.",
  "dc55d1f62f": "Cuba Sekarang",
  "b25233cba0": "Kerjasama Dokumen + Pemesejan Segera, Buka Cara Baharu untuk Pejabat yang Cekap.",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Dayakan Sembang Kumpulan Kolaboratif, Perkongsian Dokumen Selamat dan Mudah.",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Pembantu AI Lingxi, Pembantu Pintar yang Dicipta Khas untuk Pejabat.",
  "e338385bc9": "Ejen Pintar Office Asli, Mengintegrasikan AI dengan Perisian Pejabat secara Mendalam, Membolehkan Setiap Orang Memiliki Pembantu AI.",
  "7ae1f3b1c6": "Import Fail (atau Folder) Selesai, Anda Boleh Melihat Hasil Import dalam 'Dokumen Awan Saya'.",
  "85db2a024a": "Import Fail (atau Folder) Gagal, Sila Cuba Lagi Nanti.",
  "9ff74c802a": "Muat Turun Versi Cip Intel",
  "ab44928f02": "Muat Turun Versi Cip Apple",
  "a08d937c38": "Fail (atau Folder) Sedang Dimuat Naik, Boleh Dilihat dalam 'Dokumen Awan Saya' Setelah Selesai.",
  "68db1829fa": "Hanya Menyokong Import dari Akaun Peribadi, Sila Log Masuk ke Akaun Peribadi Anda dan Cuba Lagi.",
  "1185a7c7ab": "Kurang daripada 20 orang",
  "e2bcc252c9": "21-300 orang",
  "3c4842f1ea": "301-1000 orang",
  "1bbee64cfa": "Lebih daripada 1000 orang",
  "388ff4a035": "Guru",
  "d341b1d794": "Pelajar",
  "bfb2ee4148": "Lain-lain",
  "f6450c3f31": "Pengurusan Projek",
  "b87fd33a0d": "Rancangan Tahunan",
  "0dd45a1c14": "Pengurusan Prestasi Pekerja",
  "67fa01cac6": "Aktiviti Pemasaran",
  "6dd82cc031": "Pengambilan Pekerja",
  "a7edaed91d": "Bahan Pengajaran",
  "bf12b7efb0": "Pengurusan Rancangan Pengajaran",
  "c35ae8f358": "Dokumentasi Produk",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS Hamparan Berbilang Dimensi, bina sistem perniagaan eksklusif secara visual",
  "72286d5519": "👏Templat Disyorkan",
  "0bc00ee949": "Pengurusan Keperluan dan Kecacatan",
  "e22f3d56f7": "Pengurusan Penciptaan Kandungan",
  "dd439de3dd": "Sistem Pengurusan Pelanggan",
  "fbb2bbf82e": "Rancangan Persediaan Peperiksaan",
  "0645b908bc": "Pertanyaan Slip Gaji",
  "813b3d3d7e": "Pengurusan OKR",
  "918e33d5bd": "Cipta dengan Sekali Klik",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Import dokumen biasa, lebih mudah digunakan",
  "c58f28713c": "Import dari Tempatan",
  "9d6a0a4370": "Menyokong format fail Office biasa",
  "54c48aee85": "Pilih Fail",
  "c5b593e452": "Import dari Akaun Peribadi",
  "4bdcd9d4c5": "Import dokumen akaun peribadi, pasukan, folder dengan sekali klik",
  "99b2968905": "Import dengan Kebenaran",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Muat turun Klien Kolaborasi WPS",
  "fe46574227": "Kolaborasi dokumen + pemesejan segera, cara baharu untuk pejabat yang cekap",
  "beefe5a09b": "Muat turun Sekarang",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Tetapan keselamatan yang komprehensif, memastikan data selamat",
  "b4e70dbeab": "Keupayaan keselamatan dokumen WPS yang terkumpul selama bertahun-tahun, memastikan data penting syarikat tidak bocor",
  "42dc772619": "Fail terlalu besar, disyorkan untuk cuba import semula dari halaman utama kemudian",
  "a052564e47": "Penciptaan tidak berjaya, sila cuba lagi nanti",
  "790d0c428c": "Masuk ke Meja Kerja"
}